/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it

const React = require("react")
const Body = require("./src/components/body").default
exports.wrapRootElement = ({element}) => {
    return <>
    {element}
    
    </>;
}
exports.wrapPageElement = ({ element, props }) => {
    if (props.location.pathname.includes('post')) {
        return <>{element}</>;
    }
  // props provide same data to Layout as Page element will get
  // including location, data, etc - you don't need to pass it
  return <>
  <Body {...props}>{element}</Body>
  
  </>;
}

exports.onRouteUpdate = ({ location, prevLocation }) => {
    if (typeof(location) === 'undefined') return;
    let els = document.getElementsByTagName("A");
    for (var i = 0; i < els.length; i++) {
        if ((els[i].getAttribute('href') != '/') && location.pathname.includes(els[i].getAttribute('href'))
        || (els[i].getAttribute('href') == '/') && location.pathname== els[i].getAttribute('href')) {
            els[i].classList.add('selected')
        } else {
            els[i].classList.remove('selected')
        }
        
      }
  }
  
  exports.onInitialClientRender = () => {
    console.log('REMOVE');
    if (document.getElementById('splashScreen')) {
        setTimeout(() => {
            document.getElementById('splashScreen').style.opacity=0;
            document.getElementById('splashScreen').style.pointerEvents='none';
        }, 300)
       
    }
        
  }